pageId = 'teams-external_apps-wxworks-show'
page = "##{ pageId }"

$(document).on 'pjaxload#' + pageId, (e, $page, page) ->
  $('.inline-message.how-to-disconnect').on 'click', (e) ->
    e.preventDefault()
    $target = $(e.currentTarget)
    $card = $target.find('.inline-message-card')
    popover = $target.data('popover')
    unless popover
      simple.popover(
        pointTo: $target,
        content: $card.html(),
        position: 'bottom-left',
        cls: 'how-to-disconnect'
      )
